export type PGNInfo = {
  PGN: number;
  NAME: string;
  SPN: number;
  Unit: string;
  Factor: number;
  Offset: number;
  StartBit: number;
  StopBit: number;
};

const PGNs: PGNInfo[] = [
  {
    PGN: 61444,
    NAME: 'Engine Speed',
    SPN: 190,
    Unit: '1/min',
    Factor: 0.125,
    Offset: 0,
    StartBit: 24,
    StopBit: 39,
  },
  {
    PGN: 65089,
    NAME: 'Center Stop Light',
    SPN: 2375,
    Unit: 'LightStatus',
    Factor: 1,
    Offset: 0,
    StartBit: 18,
    StopBit: 19,
  },
  {
    PGN: 65089,
    NAME: 'Right Stop Light',
    SPN: 2373,
    Unit: 'LightStatus',
    Factor: 1,
    Offset: 0,
    StartBit: 20,
    StopBit: 21,
  },
  {
    PGN: 65089,
    NAME: 'Centre/Right/Left Stop Light',
    SPN: 2371,
    Unit: 'LightStatus',
    Factor: 1,
    Offset: 0,
    StartBit: 22,
    StopBit: 23,
  },
  {
    PGN: 65091,
    NAME: 'Rear PTO output shaft speed',
    SPN: 1883,
    Unit: '1/min',
    Factor: 0.125,
    Offset: 0,
    StartBit: 0,
    StopBit: 15,
  },
  {
    PGN: 65091,
    NAME: 'Rear PTO engagement',
    SPN: 2408,
    Unit: 'PTO Engagement',
    Factor: 1,
    Offset: 0,
    StartBit: 38,
    StopBit: 39,
  },
  {
    PGN: 65093,
    NAME: 'Rear hitch position',
    SPN: 1873,
    Unit: '%',
    Factor: 0.4,
    Offset: 0,
    StartBit: 0,
    StopBit: 7,
  },
  {
    PGN: 65093,
    NAME: 'Rear hitch in-work indication',
    SPN: 1877,
    Unit: 'HitchInWorkPosition',
    Factor: 1,
    Offset: 0,
    StartBit: 14,
    StopBit: 15,
  },
  {
    PGN: 65093,
    NAME: 'Rear draft',
    SPN: 1879,
    Unit: 'N',
    Factor: 10,
    Offset: -32000,
    StartBit: 24,
    StopBit: 39,
  },
  {
    PGN: 65096,
    NAME: 'Wheel-based machine speed',
    SPN: 1862,
    Unit: 'm/s',
    Factor: 0.001,
    Offset: 0,
    StartBit: 0,
    StopBit: 15,
  },
  {
    PGN: 65097,
    NAME: 'Ground-based machine speed',
    SPN: 1859,
    Unit: 'm/s',
    Factor: 0.001,
    Offset: 0,
    StartBit: 0,
    StopBit: 15,
  },
  {
    PGN: 65253,
    NAME: 'Engine Total hours of Operation',
    SPN: 247,
    Unit: 'h',
    Factor: 0.05,
    Offset: 0,
    StartBit: 0,
    StopBit: 31,
  },
  {
    PGN: 65257,
    NAME: 'Engine Trip Fuel',
    SPN: 182,
    Unit: 'l',
    Factor: 0.5,
    Offset: 0,
    StartBit: 0,
    StopBit: 15,
  },
  {
    PGN: 65262,
    NAME: 'Engine Coolant Temperature',
    SPN: 110,
    Unit: '°C',
    Factor: 1,
    Offset: -40,
    StartBit: 0,
    StopBit: 7,
  },
  {
    PGN: 65262,
    NAME: 'Engine Fuel Temperature',
    SPN: 174,
    Unit: '°C',
    Factor: 1,
    Offset: -40,
    StartBit: 8,
    StopBit: 15,
  },
  {
    PGN: 65263,
    NAME: 'Engine Oil Pressure',
    SPN: 100,
    Unit: 'kPa',
    Factor: 4,
    Offset: 0,
    StartBit: 24,
    StopBit: 31,
  },
  {
    PGN: 65266,
    NAME: 'Engine Fuel Rate',
    SPN: 183,
    Unit: 'l/h',
    Factor: 0.05,
    Offset: 0,
    StartBit: 0,
    StopBit: 15,
  },
  {
    PGN: 65269,
    NAME: 'Ambient Air Temperature',
    SPN: 171,
    Unit: '°C',
    Factor: 0.03125,
    Offset: -273,
    StartBit: 24,
    StopBit: 39,
  },
  {
    PGN: 65270,
    NAME: 'Engine Air Filter 1 Differential Pressure',
    SPN: 107,
    Unit: 'kPa',
    Factor: 0.05,
    Offset: 0,
    StartBit: 32,
    StopBit: 39,
  },
  {
    PGN: 65271,
    NAME: 'Battery Potential (Voltage), Switched',
    SPN: 158,
    Unit: 'V',
    Factor: 0.05,
    Offset: 0,
    StartBit: 48,
    StopBit: 63,
  },
  {
    PGN: 65272,
    NAME: 'Transmission Oil Pressure',
    SPN: 127,
    Unit: 'kPa',
    Factor: 16,
    Offset: 0,
    StartBit: 24,
    StopBit: 31,
  },
  {
    PGN: 65272,
    NAME: 'Transmission Oil Temperature',
    SPN: 177,
    Unit: '°C',
    Factor: 0.03125,
    Offset: 0,
    StartBit: 32,
    StopBit: 47,
  },
  {
    PGN: 61444,
    NAME: 'Engine Speed',
    SPN: 190,
    Unit: 'rpm',
    Factor: 1.0,
    Offset: 0,
    StartBit: 24,
    StopBit: 39,
  },
  {
    PGN: 61444,
    NAME: 'Actual Engine Percentage Torque',
    SPN: null,
    Unit: '%',
    Factor: 1.0,
    Offset: 0,
    StartBit: 16,
    StopBit: 23,
  },
  {
    PGN: 65110,
    NAME: 'Catalyst Level',
    SPN: null,
    Unit: '%',
    Factor: 1.0,
    Offset: 0,
    StartBit: 0,
    StopBit: 7,
  },
  {
    PGN: 65253,
    NAME: 'Total Engine Hours',
    SPN: null,
    Unit: 'h',
    Factor: 1.0,
    Offset: 0,
    StartBit: 0,
    StopBit: 31,
  },
  {
    PGN: 65262,
    NAME: 'Engine Coolant Temperature',
    SPN: null,
    Unit: 'deg',
    Factor: 1.0,
    Offset: 0,
    StartBit: 0,
    StopBit: 7,
  },
  {
    PGN: 65265,
    NAME: 'VehicleSpeed',
    SPN: null,
    Unit: 'km/h',
    Factor: 1.0,
    Offset: 0,
    StartBit: 8,
    StopBit: 23,
  },
];

export default PGNs;
